import * as types from 'store/modules/hrms16x/mutation-types'
import hrms16x from 'api/hrms16x'
import swal from 'sweetalert'
import hrms16xLabels from 'assets/labels/hrms16x'
import { hrms16xColumns } from 'assets/columns/hrms16x'
import configLabel from 'src/../config/label'

export default {
  state: {
    indexDisp: true,
    labels: hrms16xLabels,
    columns: hrms16xColumns(),
    index: {
      total: 0,
      rows: []
    },
    response: {
      status: '',
      message: ''
    }
  },
  getters: {
    [types.GET_HRMS16X_INDEX_DISP] (state) {
      return state.indexDisp
    },
    [types.GET_HRMS16X_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRMS16X_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRMS16X_INDEX] (state) {
      return state.index
    }
  },
  mutations: {
    [types.SET_HRMS16X_INDEX_DISP] (state, indexDisp) {
      state.indexDisp = indexDisp
    },
    [types.SET_HRMS16X_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].index = configLabel.replaceLabelToColumns(state.columns[keyLang].index, labels[keyLang])
      }
    },
    [types.SET_HRMS16X_LABELS] (state, labels) {
      state.labels = labels
    },
    [types.SET_HRMS16X_INDEX] (state, data) {
      state.index = data
    }
  },
  actions: {
    [types.TOGGLE_HRMS16X_PAGE] ({ commit }, page) {
      let indexDisp = false
      switch (page) {
        case 'index':
          indexDisp = true
          break
      }
      commit(types.SET_HRMS16X_INDEX_DISP, indexDisp)
    },
    [types.RECEIVED_HRMS16X_COLUMNS_LABELS] ({ commit }) {
      hrms16x.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS16X_COLUMNS, data.labels)
          commit(types.SET_HRMS16X_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRMS16X_INDEX] ({ commit }, searchParams) {
      hrms16x.getIndex(searchParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRMS16X_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
          let objData = {
            total: 0,
            rows: []
          }
          commit(types.SET_HRMS16X_INDEX, objData)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hrms16x/index.js